
import BaseLayout from "layouts/base-layout";
import React, { useEffect } from "react";
import RenderModules from "helpers/render-modules";
import { SHOPIFY_DOMAIN } from "utils/constants";
import { loadInfluencePopupScript } from "helpers/load-influence-popup";
import { useSelector } from "react-redux";
export { Head } from "components/head";
import navigate from "helpers/navigate";
import { subscriptionPageUrl } from "utils/constants";


const Page = ({ pageContext, location }) => {
	const { meta, content, pageSettings, header, footer, breadcrumbs } = pageContext;

	const path = location.pathname;
	const isHomePage = path === "/" || path === "/en";

	const { subscriptionId } = useSelector(state => state.account.subscription);

	

	useEffect(() => {
		if (isHomePage) {
			loadInfluencePopupScript();
		}
	}, []);

	useEffect(() => {
		if (subscriptionId && isHomePage)
			navigate(subscriptionPageUrl);

	}, [subscriptionId]);

	return (
		<BaseLayout
			path={path}
			header={header}
			footer={footer}
			pageSettings={pageSettings}
			breadcrumbs={breadcrumbs}
			title={meta?.title}
		>
			{content.modules && <RenderModules modules={content.modules} />}
			<div className="influenceio-widgets-init hidden"
				data-shop={ SHOPIFY_DOMAIN }
				data-platform="api"
			></div>
		</BaseLayout>
	);
};

export default Page;